export class LanguageUtil {

   public static pt = 'pt';
   public static en = 'en';
   public static es = 'es';

   public static ptNum = 1;
   public static esNum = 2;
   public static enNum = 3;

   public static isCurrentLanguagePT(language) {
      return this.pt === language || this.ptNum === language;
   }
}
